import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtom, useAtomValue } from "jotai/react";

import {
  completedOnboardingMemberIdsAtom,
  onboardingShortCodeDataAtom,
} from "@/stores/atoms";

import { PatientShortCodesApi } from "../api/patientShortCodesApi";
import { ClinicsQueryKeys } from "../queries/clinicsQueries";

export const useAssignPatientShortCodeData = () => {
  const queryClient = useQueryClient();
  const onboardingShortCodeData = useAtomValue(onboardingShortCodeDataAtom);
  const [completedMemberIds, setCompletedMemberIds] = useAtom(
    completedOnboardingMemberIdsAtom,
  );

  return useMutation({
    mutationFn: async (shortCode: string) =>
      PatientShortCodesApi.assignPatientShortCodeData({ shortCode }),
    onSuccess: () => {
      if (
        onboardingShortCodeData &&
        "memberId" in onboardingShortCodeData &&
        onboardingShortCodeData.memberId
      ) {
        const memberId = onboardingShortCodeData.memberId;
        if (!completedMemberIds.includes(memberId)) {
          setCompletedMemberIds([...completedMemberIds, memberId]);
        }
      }

      void queryClient.invalidateQueries({
        queryKey: ClinicsQueryKeys.list(),
      });
    },
  });
};
